import Dados from '@/views/admin/dados'
import DadosSave from '@/views/admin/dados/Save'
import DadosModeration from '@/views/admin/dados/Moderation'

import DadosValor from '@/views/admin/dados/values'
import DadosValorSave from '@/views/admin/dados/values/Save'

import DadosUser from '@/views/admin/dados/user/List'
import DadosUserValor from '@/views/admin/dados/user/ListValue'
import DadosUserValorSave from '@/views/admin/dados/user/ValueSave'

import DadosImport from '@/views/admin/dados/Import'

export const dados = [
  {
    path: 'dado/import',
    component: DadosImport,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    path: 'user/dado/list',
    component: DadosUser,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_dado_valor_list',
    path: 'user/dado/valor/list/:DAD_IDDADO',
    component: DadosUserValor,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_dado_valor_save',
    path: 'user/dado/valor/save/:DAD_IDDADO/:DVA_IDDADOVALOR?',
    component: DadosUserValorSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'dados_list',
    path: 'dado/list',
    component: Dados,
    meta: {
      requiresAuth: true,
      adminAuth: false
    }
  },
  {
    name: 'admin_dado_save',
    path: 'dado/save/:id?',
    component: DadosSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_dado_moderacao',
    path: 'dado/moderacao',
    component: DadosModeration,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'admin_dado_valor_list',
    path: '/dado/valor/list/:DAD_IDDADO?',
    component: DadosValor,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_dado_valor_save',
    path: 'dado/valor/save/:DAD_IDDADO/:DVA_IDDADOVALOR?',
    component: DadosValorSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/dados.js